var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-badge',{attrs:{"theme":_vm.statusClass,"outline":_vm.outline}},[_vm._v(" "+_vm._s(_vm.statusName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }